import { ChangeDetectionStrategy, Component, computed, input, model, output } from '@angular/core';
import { AgentProfileDto, AgentSocialLinksDto, AgentSocialLinksUpdateDto } from '@workspace/data-types';
import { AuraEditWrapperComponent } from '@workspace/ng-aura';
import { AgentSocialLinksDisplayComponent } from '../display/agent-social-links-display.component';
import { AgentSocialLinksFormComponent } from '../form/agent-social-links-form.component';

@Component({
  selector: 'etxe-agent-social-links-edit',
  imports: [AuraEditWrapperComponent, AgentSocialLinksFormComponent, AgentSocialLinksDisplayComponent],
  templateUrl: './agent-social-links-edit.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentSocialLinksEditComponent {
  readonly initialProfile = input<AgentProfileDto | null>(null);
  readonly initialSocialLinks = input<AgentSocialLinksDto | undefined>(undefined);
  readonly isEditing = model<boolean>(false);
  readonly isAllowedToEdit = input<boolean>(true);

  readonly saved = output<AgentSocialLinksUpdateDto>();
  readonly profileSaved = output<AgentProfileDto>();

  readonly currentSocialLinks = computed<AgentSocialLinksDto | undefined>(() => {
    return this.initialSocialLinks() ?? this.initialProfile()?.activity?.socialLinks;
  });

  onSave(dto: AgentSocialLinksUpdateDto | null): void {
    if (!dto) return;
    this.saved.emit(dto);
    const profile = this.initialProfile();
    if (profile) {
      this.profileSaved.emit({
        ...profile,
        activity: {
          ...profile.activity,
          socialLinks: dto.socialLinks,
        },
      });
    }
  }
}
